<template>
  <el-select
    v-model="value"
    placeholder="请选择"
    style="width: 180px;float:right"
    size="mini"
    id="selectDropDown"
  >
    <el-option
      v-for="item in tableHead[this.num-1]"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import { bus } from '../overviewConfig'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapMutations } = createNamespacedHelpers(
  'personnelPortraitOverview'
)
const mixin = {
  computed: {
    ...mapState({
      activeTabName: (state) => state.activeTabName
    })
  },
  methods: {
    ...mapMutations(['UPDATE_SELECTEDROPDOWN'])
    // ...mapActions([])
  }
}
export default {
  data () {
    return {
      tableHead: [
        [
          { label: '验收一次缺陷率', value: 1 },
          { label: '制作效率', value: 2 },
          { label: '制作产量', value: 3 },
          { label: '有效时长', value: 4 }
        ],
        [
          { label: '内检人员缺陷率', value: 1 },
          { label: '内检效率', value: 2 },
          { label: '内检产量', value: 3 },
          { label: '内检时长', value: 4 }
        ]
      ],
      // tableHead_neijian: ['内检人员缺陷率', '内检效率', '内检产量', '内检时长'],
      value: 'sca',
      num: 1
    }
  },
  mixins: [mixin],
  // props: ['activeTabName'],
  methods: {
    setDetailZb () {
      let colomnName = ''
      let val = 0
      if (this.activeTabName === 'zhizuo') {
        this.num = 1

        this.value = this.tableHead[0][0].value
        val = this.value
        colomnName = this.tableHead[0][val - 1].label
      } else if (this.activeTabName === 'neijian') {
        this.num = 2
        this.value = this.tableHead[1][0].value
        val = this.value
        colomnName = this.tableHead[1][val - 1].label
      }
      this.UPDATE_SELECTEDROPDOWN(val)
      bus.$emit('zb', { val, colomnName })
    }
  },
  created () {
    // console.log(this.activeTabName, 'tabname')
    this.setDetailZb()
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  watch: {
    activeTabName: function (val) {
      this.setDetailZb()
      // this.value = this.tableHead[this.activeTabName - 1][0].value
      //   this.$root.Bus.$emit('zb', val)
    },
    value: function (val) {
      // console.log(val, 'emit')
      let colomnName = ''
      colomnName = this.tableHead[this.num - 1][val - 1].label
      this.UPDATE_SELECTEDROPDOWN(val)
      bus.$emit('zb', { val, colomnName })
    }
  }
}
</script>

<style>
</style>
